import axios from 'axios';
import type { CompensationPlan } from '../models/compensationPlanTypes';

export default {
  async fetchPlan(): Promise<CompensationPlan> {
    const { data } = await axios.get('/me/company/compensation-plan');
    return data;
  },
};
